function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5",
  transform: "translate(-1395.972 -190.917)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8",
  cx: 2.326,
  cy: 2.289,
  rx: 2.326,
  ry: 2.289,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1407.966, 194.208)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8-2",
  "data-name": "path65-3-5-7-0-8",
  cx: 2.326,
  cy: 2.289,
  rx: 2.326,
  ry: 2.289,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1412.805, 201.08)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8-3",
  "data-name": "path65-3-5-7-0-8",
  cx: 2.326,
  cy: 2.289,
  rx: 2.326,
  ry: 2.289,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1410.085, 209.709)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8-4",
  "data-name": "path65-3-5-7-0-8",
  cx: 2.326,
  cy: 2.289,
  rx: 2.326,
  ry: 2.289,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1396.829, 209.164)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8-5",
  "data-name": "path65-3-5-7-0-8",
  cx: 2.326,
  cy: 2.289,
  rx: 2.326,
  ry: 2.289,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1395.972, 197.037)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_5",
  "data-name": "Ellipse 5",
  cx: 8.979,
  cy: 8.979,
  r: 8.979,
  transform: "translate(1398.245 193.812)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31",
  "data-name": "Path 31",
  d: "M203.123,179.621c-.391.843-2.968,6.92,2.655,13.756",
  transform: "translate(1207.449 15.805)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_32",
  "data-name": "Path 32",
  d: "M202.417,179.869a21.7,21.7,0,0,0-10.212,13.156",
  transform: "translate(1208.216 15.786)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_33",
  "data-name": "Path 33",
  d: "M192.473,193.9c.166,0,6.093-3.443,12.137.57",
  transform: "translate(1208.196 14.813)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M191.732,182.024c.485,1.168,5.845,9.5,15.3,3.574",
  transform: "translate(1208.253 15.62)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_35",
  "data-name": "Path 35",
  d: "M203.042,179.959s.789,4.608,4.858,5.729",
  transform: "translate(1207.384 15.779)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M202.532,179.121c-.166.249-3.815,3.49-11,2.524",
  transform: "translate(1208.268 15.843)",
  fill: "none",
  strokeWidth: 1.09
}));

const SvgGraphCircular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "current",
  stroke: "current",
  width: 23.359,
  height: 22.027,
  viewBox: "0 0 23.359 22.027",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphCircular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph-circular.a149db14.svg";
export { ForwardRef as ReactComponent };